import React, { useState, useEffect } from "react";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { Box } from "@mui/material";
import letterLogoPreview from "../assets/images/Download/letterlogs.png";
import mediaKitPreview from "../assets/images/Download/media.png";
import Archive from "../assets/images/Download/Archive.png";
import lettersPreview from "../assets/images/Download/Letter.png";


const MEDIA_KIT_FOLDER_PREVIEWS = {
  "Archive": Archive,
  "Media Kit": mediaKitPreview,
  "Letters": lettersPreview,
};

const API_KEY = "AIzaSyBzcAiQlryjAWkEfRxxb_HFy5aKnJR7x2A"; 

const TABS = [
  {
    label: "Archive",
    folderId: "1LryrcZFX9_6UGriry5709NppLat8g_CR",
  },
  {
    label: "Letters & Invites",
    folderId: "1dACMNoXobIfAdLjEHhND0qbma14-fH5j",
  },
  {
    label: "Media Kit",
    folderId: "1s7rTU_uG9czIKkpJ-ywLZ1oldTXrR5cx",
  },
  {
    label: "Logos, QR & Fonts",
    folderId: "1BiHgronihnCqfZuTeOzuhApk-CRdw-aA",
  },
  {
    label: "Publications",
    folderId: "1nkjbNQ7W_yUc3Yb0t_EEGYRccnYTq9OB",
  },
];

export default function DownloadPage() {
  const [activeTab, setActiveTab] = useState(0);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [folderLoading, setFolderLoading] = useState(false);
  const [activeFolder, setActiveFolder] = useState(null); // For nested folder navigation
  const [folderStructure, setFolderStructure] = useState({}); // Store folder hierarchy

  // 🔄 Fetch files when tab changes
  useEffect(() => {
    setActiveFolder(null); // Reset folder when tab changes
    fetchFiles(TABS[activeTab].folderId, TABS[activeTab].label);
  }, [activeTab]);

  const fetchFiles = async (folderId, tabLabel) => {
    try {
      setLoading(true);

      const res = await fetch(
        `https://www.googleapis.com/drive/v3/files?q='${folderId}'+in+parents&key=${API_KEY}&fields=files(id,name,mimeType,thumbnailLink)`
      );

      const data = await res.json();
      let files = data.files || [];
      

      
      setFiles(files);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  // 📁 Handle folder click for nested navigation
  const handleFolderClick = async (folderId) => {
    if (TABS[activeTab].label === "Logos, QR & Fonts" || TABS[activeTab].label === "Media Kit") {
      setActiveFolder(folderId);
      setLoading(true);
      
      try {
        const res = await fetch(
          `https://www.googleapis.com/drive/v3/files?q='${folderId}'+in+parents&key=${API_KEY}&fields=files(id,name,mimeType,thumbnailLink)`
        );
        const data = await res.json();
        setFiles(data.files || []);
      } catch (error) {
        console.error("Error fetching folder contents:", error);
        setFiles([]);
      } finally {
        setLoading(false);
      }
    }
  };

  // 🏠 Handle back to main folder
  const handleBackToMain = () => {
    if (TABS[activeTab].label === "Logos, QR & Fonts" || TABS[activeTab].label === "Media Kit") {
      setActiveFolder(null);
      fetchFiles(TABS[activeTab].folderId, TABS[activeTab].label);
    }
  };

  // 📦 Download entire folder as ZIP
  const downloadFolder = async (folderId, folderName) => {
    try {
      setFolderLoading(true);

      const listRes = await fetch(
        `https://www.googleapis.com/drive/v3/files?q='${folderId}'+in+parents&key=${API_KEY}&fields=files(id,name,mimeType)`
      );

      const data = await listRes.json();
      const zip = new JSZip();

      for (const file of data.files) {
        const fileRes = await fetch(
          `https://www.googleapis.com/drive/v3/files/${file.id}?alt=media&key=${API_KEY}`
        );

        const blob = await fileRes.blob();
        zip.file(file.name, blob);
      }

      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, `${folderName}.zip`);
    } catch (error) {
      console.error("Download error:", error);
    } finally {
      setFolderLoading(false);
    }
  };
  

  return (
    
    <div style={{ padding: "", fontFamily: "var(---default-font)" }}>
    {/* 🔵 Banner Image */}
<div
  style={{
    width: "100%",
    height: "100%",
    objectFit:"cover"
  }}
>
  <Box
  className="downloadBg commonBannerBg"
 sx={{
          width: "100%",
          height: { xs: "250px", md: "400px" },
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
 }}
/>
</div>
      <h1 style={{ textAlign: "center" }}>Download Center</h1>

      {/* Tabs */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          justifyContent: "center",
          alignItems: "center",
          marginLeft: "6.5%",
          marginRight: "5%",
          fontFamily: "var(--default-font)",
          marginBottom: "30px",
          height: "100%",
          flexWrap: "wrap"
        }}
      >
        {TABS.map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveTab(index)}
            style={{
              padding: "12px 16px",
              fontSize: "14px",
              lineHeight: "18px",
              cursor: "pointer",
              fontFamily: "var(--default-font) !important",
              background:
                activeTab === index
                  ? "linear-gradient(90deg, #4b77b1,#005498)"
                  : "#e0e0e0",
              color: activeTab === index ? "#fff" : "#000",
              border: "none",
              borderRadius: "6px",
              minWidth: "120px",
              flex: "1 1 auto",
              maxWidth: "200px",
              textAlign: "center",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Loading */}
      {loading && <p style={{ textAlign: "center" }}>Loading files...</p>}

      {/* Folder Navigation for Logos, QR & Fonts and Media Kit */}
      {(TABS[activeTab].label === "Logos, QR & Fonts" || TABS[activeTab].label === "Media Kit") && activeFolder && (
        <div style={{ 
          marginBottom: "20px", 
          textAlign: "center",
          fontFamily:"var(--default-font)"
        }}>
          <button
            onClick={handleBackToMain}
            style={{
              padding: "10px 20px",
              fontSize:"100%",
              cursor: "pointer",
              fontFamily:"var(--default-font) !important",
              background: "linear-gradient(90deg, #4b77b1,#005498)",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              marginRight: "10px",
              textAlign: "center"
            }}
          >
            ← Back to Main
          </button>
          <span style={{ 
            fontSize: "16px", 
            fontWeight: "bold",
            fontFamily:"var(--default-font)"
          }}>
            {files.find(f => f.id === activeFolder)?.name || "Selected Folder"}
          </span>
        </div>
      )}

      {/* Files Grid */}
      <div
        style={{
          display: "grid",
    marginBottom: "100px",
    gridTemplateColumns: "repeat(auto-fit, 250px)", // fixed card width
    justifyContent: "center",  //  THIS CENTERS THE WHOLE ROW
    columnGap: "10px",
    rowGap: "35px",
    width: "100%",
    margin: "0",
    padding: "0 5px",
    fontFamily: "var(--default-font) !important"
 }}
      >
        {files.map((file) => (
          <div
            key={file.id}
            style={{
              border: "1px solid #ddd",
              padding: "10px",
              borderRadius: "10px",
              textAlign: "center",
              height: "100%",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",     
              cursor: TABS[activeTab].label === "Logos, QR & Fonts" && file.mimeType === "application/vnd.google-apps.folder" ? "pointer" : "default",
              transition: "transform 0.2s, box-shadow 0.2s",
            }}
            onClick={() => {
              if ((TABS[activeTab].label === "Logos, QR & Fonts" || TABS[activeTab].label === "Media Kit") && file.mimeType === "application/vnd.google-apps.folder") {
                handleFolderClick(file.id);
              }
            }}
            onMouseEnter={(e) => {
              if ((TABS[activeTab].label === "Logos, QR & Fonts" || TABS[activeTab].label === "Media Kit") && file.mimeType === "application/vnd.google-apps.folder") {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.3)";
              }
            }}
            onMouseLeave={(e) => {
              if ((TABS[activeTab].label === "Logos, QR & Fonts" || TABS[activeTab].label === "Media Kit") && file.mimeType === "application/vnd.google-apps.folder") {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.2)";
              }
            }}
          >
    <img
  src={
    file.mimeType === "application/vnd.google-apps.folder"
      ? (MEDIA_KIT_FOLDER_PREVIEWS[file.name] || (
          TABS[activeTab].label === "Archive" ? Archive
          : TABS[activeTab].label === "Letters & Invites" ? lettersPreview
          : TABS[activeTab].label === "Logos, QR & Fonts" ? letterLogoPreview
          : mediaKitPreview
        ))
      : TABS[activeTab].label === "Letters & Invites"
      ? (file.mimeType === "application/pdf" || file.name.toLowerCase().endsWith('.pdf')
          ? `https://drive.google.com/thumbnail?id=${file.id}&sz=w1500`
          : lettersPreview)
      : TABS[activeTab].label === "Archive"
      ? (file.mimeType === "application/pdf" || file.name.toLowerCase().endsWith('.pdf')
          ? `https://drive.google.com/thumbnail?id=${file.id}&sz=w1500`
          : Archive)
      : TABS[activeTab].label === "Logos, QR & Fonts"
      ? (file.mimeType === "application/pdf" || file.name.toLowerCase().endsWith('.pdf') || file.mimeType.startsWith("image/")
          ? `https://drive.google.com/thumbnail?id=${file.id}&sz=w1500`
          : letterLogoPreview)
      : TABS[activeTab].label === "Media Kit"
      ? (file.mimeType === "application/pdf" || file.name.toLowerCase().endsWith('.pdf')
          ? `https://drive.google.com/thumbnail?id=${file.id}&sz=w1500`
          : mediaKitPreview)
      : `https://drive.google.com/thumbnail?id=${file.id}&sz=w1500`
  }
  onError={(e) => {
    const tab = TABS[activeTab].label;
    if (tab === "Letters & Invites") e.target.src = lettersPreview;
    else if (tab === "Archive") e.target.src = Archive;
    else if (tab === "Logos, QR & Fonts") e.target.src = letterLogoPreview;
    else e.target.src = mediaKitPreview;
    e.target.onerror = null;
  }}
  alt={file.name}
  style={{
    width: "100%",
    height: "300px",
    objectFit: "cover",
    borderRadius: "12px",
    marginBottom: "10px",
  }}
/>

            <p style={{ fontSize: "14px",fontWeight:"bold", wordBreak: "break-word", minHeight: "40px" }}>
              {file.name}
            </p>

<div
  style={{
    display: "flex",
    justifyContent: "center",
    marginTop: "10px"
  }}
>
  {file.mimeType === "application/vnd.google-apps.folder" && (TABS[activeTab].label === "Logos, QR & Fonts" || TABS[activeTab].label === "Media Kit") ? (
    <button
      onClick={(e) => {
        e.stopPropagation();
        handleFolderClick(file.id);
      }}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px",
        fontFamily: "var(--default-font)",
        background: "linear-gradient(90deg, #4b77b1,#005498)",
        color: "white",
        width: "12rem",
        borderRadius: "5px",
        fontWeight: "bold",
        fontSize: "16px",
        border: "none",
        cursor: "pointer"
      }}
    >
      Open Folder
    </button>
  ) : (
    <a
      href={`https://drive.google.com/uc?export=download&id=${file.id}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px",
        fontFamily: "var(--default-font)",
        background: "linear-gradient(90deg, #4b77b1,#005498)",
        color: "white",
        width: "12rem",
        borderRadius: "5px",
        fontWeight: "bold",
        fontSize: "16px",
        textDecoration: "none"
      }}
    >
      Download
    </a>
  )}
</div>
          </div>
        ))}
      </div>

      {/* Full Folder Download Button */}
      <div style={{ textAlign: "center", marginTop: "40px" }}>
        <button
          onClick={() =>
            downloadFolder(
              TABS[activeTab].folderId,
              TABS[activeTab].label
            )
          }
          disabled={folderLoading}
          className=".blueButton"
          style={{
            padding: "10px 20px",
 background:"linear-gradient(90deg, #4b77b1,#005498)",
               color:"white",            border: "none",
            borderRadius: "6px",
            fontFamily:"var(--default-font)",
            cursor: "pointer",
          }}
        >
          {folderLoading ? "Preparing ZIP..." : "Download Full Folder"}
        </button>
      </div>
    </div>
  );
}